/**
 * MIME types a downloaded file may be opened as in a browser tab. A `blob:` URL has the portal's origin, so
 * anything that can run script (SVG, HTML, XML, …) must never be opened; it is downloaded instead.
 * The type comes from a third party (e.g. Zoho via the hub proxy), so it is matched exactly.
 */
const VIEWABLE_TYPES: ReadonlySet<string> = new Set([
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  'application/pdf',
]);

/** Whether a blob of this exact MIME type is safe to open in a tab. */
export function isViewableBlobType(type: string): boolean {
  return VIEWABLE_TYPES.has(type);
}

/**
 * The blob to hand to `URL.createObjectURL`: unchanged when it is safe to view, otherwise re-typed as
 * `application/octet-stream` so the browser can only save it, never render it.
 */
export function toSafeBlob(blob: Blob): Blob {
  return isViewableBlobType(blob.type) ? blob : new Blob([blob], { type: 'application/octet-stream' });
}
